var map = {
	"./de.json": "05ab",
	"./en.json": "acfc",
	"./en00.json": "95dc",
	"./fin.json": "92d9",
	"./fra.json": "c383",
	"./it.json": "cbb7",
	"./jp.json": "efe6",
	"./kor.json": "9d27",
	"./pl.json": "f353",
	"./pt.json": "d3eb",
	"./spa.json": "21c8",
	"./swe.json": "1d68",
	"./tr.json": "9c68",
	"./ukr.json": "0162",
	"./zh-CN.json": "46ff",
	"./zh-CN00.json": "41a1",
	"./zh-TW.json": "2259"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ff5";